import { map } from 'rxjs/operators';

import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { ApiService } from '@core/services';
import { IonSelect, Platform } from '@ionic/angular';

import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  #apiService: ApiService = inject(ApiService);
  errors: string;
  driver = false;
  form;
  iabOptions: InAppBrowserOptions = {
    location: 'no',
    hidenavigationbuttons: 'yes',
    toolbarposition: 'bottom',
    toolbarcolor: '#0e53a1',
    navigationbuttoncolor: '#ffffff',
    hideurlbar: 'yes',
    closebuttoncaption: 'Cerrar',
  };
  mitec$ = this.#apiService
    .get<boolean>('saml2/mitec')
    .pipe(map((res) => (Capacitor.isNativePlatform() ? res : false)));
  @ViewChild('mySelect') selectRef: IonSelect;

  constructor(
    private router: Router,
    private iab: InAppBrowser,
    private auth: AuthService,
    private formBuilder: UntypedFormBuilder,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[A-Z0-9a-z._%±]+@([A-Za-z0-9-]+.)+[A-Za-z]{2,4}$')]],
      password: ['', Validators.required],
      pincode: [''],
      termsAccepted: [false, Validators.requiredTrue],
    });
  }

  showCampus() {
    this.selectRef.open();
  }

  login() {
    if (this.form.valid) {
      this.auth.login(this.form.value).then((res) => {
        this.errors = typeof res === 'string' ? res : 'Usuario o contraseña incorrecta';
      });
    } else if (this.driver && this.form.controls.pincode.dirty && this.form.controls.pincode.valid) {
      this.auth.loginDriver(this.form.value).then((res) => {
        this.errors = typeof res === 'string' ? res : 'Usuario o contraseña incorrecta';
      });
    }
  }

  goForgot() {
    this.router.navigate(['/forgot-password']);
  }

  onTermsChecked($event) {
    if (!$event.detail.checked) {
      this.form.controls.termsAccepted.setValue(false);
    } else {
      this.form.controls.termsAccepted.setValue(true);
    }
  }

  goTerms(campus) {
    this.iab.create(
      (this.platform.is('ios') ? '' : '') + 'https://tecservice.app/terminosycondiciones?campus=' + campus,
      '_blank',
      this.iabOptions
    );
  }

  async sso(): Promise<void> {
    await this.auth.singleSignOn();
  }
}
